import { defineComponent, openBlock, createElementBlock } from "vue";
const _hoisted_1 = ["innerHTML"];
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "HTMLContentModal",
  props: {
    htmlContent: {}
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", {
        class: "cms-modal",
        innerHTML: _ctx.htmlContent
      }, null, 8, _hoisted_1);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=HTMLContentModal.mjs.map
